import { Link } from 'react-router-dom';
import { ToolMeta } from '../data/toolRegistry';
import { ArrowRight } from 'lucide-react';

interface ToolCardProps {
  tool: ToolMeta;
}

export function ToolCard({ tool }: ToolCardProps) {
  const categoryStyles = {
    microeconomics: 'bg-indigo-50 text-indigo-700 border-indigo-100 dark:bg-indigo-950/20 dark:text-indigo-400 dark:border-indigo-900/30',
    macroeconomics: 'bg-emerald-50 text-emerald-700 border-emerald-100 dark:bg-emerald-950/20 dark:text-emerald-400 dark:border-emerald-900/30',
    data: 'bg-amber-50 text-amber-700 border-amber-100 dark:bg-amber-950/20 dark:text-amber-400 dark:border-amber-900/30',
    finance: 'bg-blue-50 text-blue-700 border-blue-100 dark:bg-blue-950/20 dark:text-blue-400 dark:border-blue-900/30',
  };

  const difficultyStyles = {
    intro: 'text-slate-500 bg-slate-100 dark:text-slate-400 dark:bg-slate-900',
    intermediate: 'text-amber-700 bg-amber-50 border border-amber-100 dark:text-amber-400 dark:bg-amber-950/20 dark:border-amber-900/30',
    advanced: 'text-rose-700 bg-rose-50 border border-rose-100 dark:text-rose-400 dark:bg-rose-950/20 dark:border-rose-900/30',
  };

  return (
    <div className="group relative flex flex-col justify-between bg-white dark:bg-slate-900 border border-slate-200/60 dark:border-slate-800/80 rounded-xl p-5 hover:shadow-md hover:border-slate-300 dark:hover:border-slate-700 transition-all duration-200">
      <div>
        {/* Badges */}
        <div className="flex items-center justify-between gap-2 mb-3.5">
          <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full border ${categoryStyles[tool.category]}`}>
            {tool.category === 'data' ? 'Data & Policy' : tool.category}
          </span>
          <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-md ${difficultyStyles[tool.difficulty]}`}>
            {tool.difficulty}
          </span>
        </div>

        {/* Info */}
        <h3 className="text-base font-bold font-display text-slate-800 dark:text-slate-200 mb-1.5 group-hover:text-brand-500 transition-colors">
          {tool.shortTitle}
        </h3>
        <p className="text-xs text-slate-500 dark:text-slate-400 leading-relaxed line-clamp-2">
          {tool.description}
        </p>
      </div>

      <div className="mt-5 border-t border-slate-100 dark:border-slate-800 pt-3.5 flex items-center justify-end">
        <Link
          to={tool.route}
          className="inline-flex items-center gap-1 text-xs font-bold text-brand-600 dark:text-brand-400 hover:text-brand-700 dark:hover:text-brand-300 transition-colors"
        >
          <span>Open Tool</span>
          <ArrowRight className="w-3.5 h-3.5 transform group-hover:translate-x-0.5 transition-transform" />
        </Link>
      </div>
    </div>
  );
}
